module.exports = __webpack_public_path__ + "img/loan-memo-img.1707c2a7.png";